import { z } from 'zod';

export const rolesSchema = z.enum([
  'ALK Administrator',
  'ALK Support',
  'Partner Administrator',
  'Support',
  'Company Administrator',
  'User',
]);
